/**
 * Language selector component with persistence
 * Allows switching between French and Dutch
 */

import type React from "react";
import { type Language, useI18n } from "../../lib/i18n";

/**
 * Props for LanguageSelector component
 */
interface LanguageSelectorProps {
  className?: string;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  className,
}) => {
  const { language, setLanguage, isLoaded } = useI18n();

  /**
   * Handles language change
   * @param newLanguage - The new language to set
   */
  const handleLanguageChange = (newLanguage: string) => {
    if (newLanguage === "fr" || newLanguage === "nl") {
      setLanguage(newLanguage as Language);
    }
  };

  // Loading display if translations are not yet loaded
  if (!isLoaded) {
    return (
      <div className={`animate-pulse ${className}`}>
        <div className="h-10 w-24 bg-gray-200 rounded"></div>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className || ""}`.trim()}>
      <button
        type="button"
        onClick={() => handleLanguageChange("fr")}
        className={`text-tm-md font-semibold ${
          language === "fr"
            ? "text-blue-700 underline"
            : "text-blue-700 hover:underline"
        }`}
      >
        FR
      </button>
      <span className="text-tm-md text-blue-700">|</span>
      <button
        type="button"
        onClick={() => handleLanguageChange("nl")}
        className={`text-tm-md font-semibold ${
          language === "nl"
            ? "text-blue-700 underline"
            : "text-blue-700 hover:underline"
        }`}
      >
        NL
      </button>
    </div>
  );
};

export default LanguageSelector;
